<template>
  <div class="textareaEditorBox" v-loading="loading">
    <el-link v-if="showExample" class="link-tips" type="danger" target="_blank" href="http://localhost:8080/img/bc.81402ab2.png">查看优质范例</el-link>
    <div id="textareaEditor"></div>
  </div>
</template>

<script>
// 引入 wangEditor
import wangEditor from 'wangeditor';
import upload from '@/utils/upload';

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    showExample: {
      type: String,
      default: '',
    },
    height: {
      type: Number,
      default: 500
    },
  },
  data() {
    return {
      editor: null,
      editorData: '',
      loading: false,
      pictureSize: 100,
      videoSize: 100,
      href: ''
    };
  },
  watch: {
    disabled: {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.editor.disable();
          });
          return;
        }
        this.$nextTick(() => {
          this.editor.enable();
        });
      },
      immediate: true,
    }
  },
  mounted() {
    let editor = new wangEditor(`#textareaEditor`);
    const _this = this;
    editor.config.height = this.height;
    editor.config.zIndex = 1000;
    editor.config.width = '100%';
    // 菜单栏
    editor.config.menus = [
      'head',
      'bold',
      'fontSize',
      'italic',
      'underline',
      'strikeThrough',
      'indent',
      'lineHeight',
      'foreColor',
      'backColor',
      'list',
      'justify',
      'image',
      'video',
      'splitLine',
      'undo',
      'redo',
    ];

    // -------------------上传图片
    editor.config.showLinkImg = false;
    editor.config.uploadImgMaxSize = this.pictureSize * 1024 * 1024;
    editor.config.uploadImgAccept = ['jpg', 'jpeg', 'png'];

    editor.config.customUploadImg = async function (resultFiles, insertImgFn) {
      _this.loading = true;
      // 按照顺序await调用，不要用map,reduce ,forEach.
      for (const file of resultFiles) {
        const { success, src, err } = await upload(
          process.env.VUE_APP_CML_BASE_URL + 'file/image/upload',
          file,
        );
        if (success === '1' && !err) {
          // 上传图片，返回结果，将图片插入到编辑器中
          insertImgFn(src + _this.$textareaQuality);
        } else {
          this.$message.error(err.msg);
        }
      }
      _this.loading = false;
    };
   
    editor.config.showLinkVideo = false;
    editor.config.uploadVideoMaxSize = this.videoSize * 1024 * 1024;
    editor.config.uploadVideoAccept = ['mp4', 'avi', 'wmv', 'flv', 'mov'];
  
    // -------------------上传视频
    editor.config.customUploadVideo = async function (resultFiles, insertVideoFn) {
      if(resultFiles[0].type !== 'video/mp4') {
        _this.$message.error('请选择MP4格式的视频上传');
        return;
      }
      _this.loading = true;
      // 视频暂时只支持单个上传
      // 按照顺序await调用，不要用map,reduce ,forEach.
      for (const file of resultFiles) {
        const { success, src, err } = await upload(
          process.env.VUE_APP_CML_BASE_URL + 'file/upload',
          file,
        );
        if (success === '1' && !err) {
          // 上传图片，返回结果，将图片插入到编辑器中
          insertVideoFn(src);
        } else {
          _this.$message.error(err.msg);
        }
      }
      _this.loading = false;
    };

    // 创建编辑器
    this.editor = editor;
    this.editor.create();
  },
  methods: {
    getHtml() {
      // 获取编辑器内容
      const allHtml = this.editor.txt.html();
      const imgLabel = allHtml.match(/<img.*?>/g) || [];
      const imgUrls = imgLabel.map(url => {
        return url.match(/\ssrc=['"](.*?)['"]/)[1];
      });
      // const videoLabel = allHtml.match(/<video.*?>/g) || [];
      // const videoUrls = videoLabel.map(url => {
      //   return url.match(/\ssrc=['"](.*?)['"]/)[1];
      // });
      const text = this.editor.txt.text();
      return {
        allHtml,
        imgUrls,
        text,
      };
    },
    setHtml(html) {
      this.editor.txt.html(html);
    },
    clear() {
      this.editor && this.editor.txt.clear();
    },
  },
  beforeDestroy() {
    // 调用销毁 API 对当前编辑器实例进行销毁
    this.editor.destroy();
    this.editor = null;
  },
};
</script>

<style lang="less" scoped>
#textareaEditor {
  width: 800px;
  margin-top: 5px;
}
.link-tips {
  position: absolute;
  left: -85px;
  top: 24px;
}
</style>
